/**
 * 按 EB setings.vue setLocalTheme 逻辑应用主题色（columns / defaults 优先）
 */
import type { CrmebThemeConfigState } from '@/store/modules/themeConfig';
import {
  CRMEB_THEME_PRESETS,
  THEME_PRIMARY_MAP,
} from '@/layout/navBars/crmebThemePresets';

export function applyCrmebThemePalette(
  themeStyle: string,
  layout: CrmebThemeConfigState['layout'],
): Partial<CrmebThemeConfigState> {
  const preset = { ...(CRMEB_THEME_PRESETS[themeStyle] || CRMEB_THEME_PRESETS['theme-1']) };
  preset['--prev-border-color-lighter'] = '#ebeef5';
  const primary = THEME_PRIMARY_MAP[themeStyle] || '#4073FA';

  if (layout === 'columns') {
    preset['--prev-bg-topBar'] = '#fff';
    preset['--prev-bg-topBarColor'] = '#515a6e';
    preset['--prev-bg-menuBar'] = '#fff';
    preset['--prev-bg-menuBarColor'] = '#303133';
    preset['--prev-border-color-lighter'] = '#ebeef5';
    if (themeStyle === 'theme-1' || themeStyle === 'theme-2' || themeStyle === 'theme-9') {
      preset['--prev-bg-menu-hover-ba-color'] = '#e8f4ff';
      preset['--prev-MenuActiveColor'] = primary;
    } else if (themeStyle === 'theme-3' || themeStyle === 'theme-4') {
      preset['--prev-bg-menu-hover-ba-color'] = '#ecf8f3';
      preset['--prev-MenuActiveColor'] = primary;
    } else if (themeStyle === 'theme-5' || themeStyle === 'theme-6') {
      preset['--prev-bg-menu-hover-ba-color'] = '#f0eefe';
      preset['--prev-MenuActiveColor'] = primary;
    } else if (themeStyle === 'theme-7' || themeStyle === 'theme-8') {
      preset['--prev-bg-menu-hover-ba-color'] = '#feedeb';
      preset['--prev-MenuActiveColor'] = primary;
    }
  } else if (layout === 'defaults') {
    // 对齐 EB setings.vue setLocalTheme「默认布局」分支
    if (['theme-2', 'theme-4', 'theme-6', 'theme-8'].includes(themeStyle)) {
      preset['--prev-bg-menuBar'] = '#ffffff';
      preset['--prev-bg-menuBarColor'] = '#515a6e';
      preset['--prev-bg-menu-hover-ba-color'] = preset['--prev-bg-menu-hover-ba-color'] || '#e8f4ff';
      preset['--prev-MenuActiveColor'] = primary;
    } else {
      // 蓝黑/绿黑/紫黑/红黑：侧栏深底 + 选中用主题主色（勿用半透明灰）
      const darkHover: Record<string, string> = {
        'theme-1': '#4073FA',
        'theme-3': '#41b584',
        'theme-5': '#6954f0',
        'theme-7': '#f34d37',
      };
      preset['--prev-bg-menuBar'] = '#282c34';
      preset['--prev-bg-menuBarColor'] = '#fff';
      preset['--prev-MenuActiveColor'] = '#fff';
      preset['--prev-bg-menu-hover-ba-color'] = darkHover[themeStyle] || primary;
    }
    preset['--prev-bg-topBar'] = '#fff';
    preset['--prev-bg-topBarColor'] = '#282c34';
  } else if (layout === 'classic' || layout === 'transverse') {
    /* 对齐 EB setings.vue setLocalTheme classic / transverse 分支 */
    const darkThemeHover: Record<string, string> = {
      'theme-1': '#4073FA',
      'theme-3': '#41b584',
      'theme-5': '#6954f0',
      'theme-7': '#f34d37',
    };
    preset['--prev-border-color-lighter'] = '#ebeef5';
    preset['--prev-bg-topBar'] = '#282c34';
    preset['--prev-bg-topBarColor'] = '#fff';
    if (themeStyle in darkThemeHover) {
      preset['--prev-bg-menu-hover-ba-color'] = darkThemeHover[themeStyle];
      preset['--prev-MenuActiveColor'] = '#fff';
    } else if (['theme-2', 'theme-4', 'theme-6', 'theme-8'].includes(themeStyle)) {
      preset['--prev-border-color-lighter'] = '#ebeef5';
      preset['--prev-bg-topBar'] = '#fff';
      preset['--prev-bg-topBarColor'] = '#515a6e';
      preset['--prev-MenuActiveColor'] = primary;
    }
    if (layout === 'classic') {
      /* 经典布局：顶栏深色 + 左侧子菜单白底深字 */
      preset['--prev-bg-menuBar'] = '#fff';
      preset['--prev-bg-menuBarColor'] = '#282c34';
    }
  }

  const root = document.documentElement;
  Object.entries(preset).forEach(([key, val]) => {
    root.style.setProperty(key, val);
  });

  return {
    primary,
    topBar: preset['--prev-bg-topBar'] || '#ffffff',
    topBarColor: preset['--prev-bg-topBarColor'] || '#515a6e',
    menuBar: preset['--prev-bg-menuBar'] || '#282c34',
    menuBarColor: preset['--prev-bg-menuBarColor'] || '#eaeaea',
    columnsMenuBar: preset['--prev-bg-columnsMenuBar'] || '#282c34',
    columnsMenuBarColor: preset['--prev-bg-columnsMenuBarColor'] || '#e6e6e6',
  };
}

export function applyBodyFilter(isGrayscale: boolean, isInvert: boolean) {
  const parts: string[] = [];
  if (isGrayscale) parts.push('grayscale(1)');
  if (isInvert) parts.push('invert(80%)');
  document.body.setAttribute(
    'style',
    parts.length ? `filter: ${parts.join(' ')}` : '',
  );
}
